import { render, staticRenderFns } from "./CreateOfficerChange.vue?vue&type=template&id=68d72e96&"
import script from "./CreateOfficerChange.vue?vue&type=script&lang=js&"
export * from "./CreateOfficerChange.vue?vue&type=script&lang=js&"
import style0 from "./CreateOfficerChange.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports